import { StockOverviewPage, StockDetailPage } from "@clubInventory/stock";
import { CLUB_INVENTORY_ROUTER } from "./routerPath";
import { FRONT_KEY } from "@clubInventory/constants/frontKey";

/**
 * 庫存管理路由配置
 */
const stockRouter = [
	{
		description: "庫存總覽",
		exact: true,
		path: CLUB_INVENTORY_ROUTER.STOCK.OVERVIEW,
		href: CLUB_INVENTORY_ROUTER.STOCK.OVERVIEW,
		as: StockOverviewPage,
		frontKey: FRONT_KEY.STOCK_OVERVIEW,
	},
	{
		description: "商品庫存明細",
		exact: true,
		path: CLUB_INVENTORY_ROUTER.STOCK.DETAIL,
		as: StockDetailPage,
		frontKey: FRONT_KEY.STOCK_DETAIL,
	},
];

export default stockRouter;
